import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		title: {
			flexGrow: 1,
		},
		drawer: {
			width: 300,
		},
		fullList: {
			width: "auto",
		},
		//toolbar: theme.mixins.toolbar,
		infoUsuario: {
			height: 70,
			fontWeight: "bold",
		},
	})
);
export default useStyles;
